export default {
    appName: 'Цифровая платформа MOEX',
    serviceNotAvailable: 'Сервис временно недоступен',
    tryAgainLater: 'Пожалуйста, попробуйте зайти через 5 минут или позже',
    goBackHome: 'Вернуться на главную',
    pageNotExist: 'Такой страницы больше нет или она никогда не существовала',
};
